<template>
  <div class="box">
    <el-form :model="info" label-position="right" :rules="rules" ref="ruleForm" label-width="80px" size="small">
      <el-form-item label="标题" prop="title">
        <el-input v-model="info.title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="ordering">
        <el-input type="number" v-model="info.ordering" placeholder="请输入排序"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>

export default {
  data() {
    return {
      info: {
        id: 0,
        title: '',
        ordering: ''
      },
      rules: {
        title: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
  },
  mounted() {
  },
  computed: {
  },
  props: {
    id: Number,
    callFunc: Function
  },
  watch: {
    'id': {
      handler (newValue, oldValue) {
        this.info.id = newValue
        this.getInfo()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getInfo() {
      if(this.info.id) {
        this.$api.merchant.helpMenuDetail({id: this.info.id}, res => {
          if(res.errcode == 0) {
            this.info = res.data
          } else {
            this.fail(res.errmsg)
          }
        })
      } else {
        this.info.id = 0
        this.info.title = ''
        this.info.ordering = ''
      }
    },
    submitForm(formName) {
      var _this = this
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          var param = _this.info
          this.$api.merchant.helpMenuEdit(param,function (res) {
            if(res.errcode == 0) {
              _this.success(res.errmsg)
              _this.callFunc()
            } else {
              _this.fail(res.errmsg)
            }
          })
        } else {
          return false;
        }
      });
    },
  }
};
</script>
<style scoped>
</style>
